import { Guid } from "guid-typescript";

export function reflectChipsValues(initialNewString = '', valueToSplit: string) {
    let newStr = initialNewString
    const splittedItem = valueToSplit.split(',')

    splittedItem.forEach((part, index, arr) => {
      if (part[part.length - 1] !== '\\' && index !== arr.length - 1) {
        newStr += part + '\\,'
      } else if (part[part.length - 1] === '\\' && index !== arr.length - 1) {
        newStr += part + ','
      } else {
        newStr += part
      }
    })

    return newStr
}

export function reflectedStringToList(value: string) {
  const hash = Guid.create().toString()
  const arr = String(String(value).replaceAll(/\\,/g, hash)).split(/\s*,\s*/u)

  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].replaceAll(hash, ',')
  }

  return arr
}
